module.exports = __webpack_public_path__ + "img/quotebubble2.f178e470.png";